{
  "seed-bible": "Seed Bible",
  "allBooks": "All books",
  "new-testament": "New Testament",
  "old-testament": "Old Testament",
  "books": "Books",
  "search": "Search",
  "settings": "Settings",
  "side-menu": "Side menu",
  "copy-verse": "Copy",
  "next-chapter": "Next Chapter",
  "previous-chapter": "Previous Chapter",
  "share-verse": "Share",
  "share-session": "Share session",
  "cancel": "Cancel",
  "close": "Close",
  "open-settings": "Open Settings",
  "close-settings": "Close Settings",
  "session-settings": "Session settings",
  "shared-session-click-to-join": "is sharing — click to join",
  "dismiss": "Dismiss",
  "tabs": "Tabs",
  "new-tab": "New tab",
  "create-new-tab": "Create new tab",
  "tab-options": "Tab options",
  "open-tab-menu": "Open tab menu",
  "search-verses": "Search verses",
  "clear-search": "Clear search",
  "searching": "Searching...",
  "no-search-results": "No matching verses.",
  "open-chapter": "Open chapter",
  "account-settings": "Account settings",
  "account-settings-intro": "Manage your profile information here",
  "profile-picture": "Profile picture",
  "update-picture": "Update picture",
  "uploading": "Uploading...",
  "take-photo": "Take a photo",
  "choose-from-gallery": "Choose from gallery",
  "upload-a-file": "Upload a file",
  "crop-your-photo": "Crop your photo",
  "zoom": "Zoom",
  "set-picture": "Set picture",
  "profile-name": "Profile name",
  "profile-name-placeholder": "e.g Craig family",
  "profile-name-helper": "You can change this later",
  "description": "Description",
  "optional": "(Optional)",
  "description-placeholder": "Enter your profile description...",
  "location": "Location",
  "location-placeholder": "e.g Austin,TX",
  "your-id-is": "Your ID is:",
  "copy-user-id": "Copy user ID",
  "copied": "Copied",
  "copy": "Copy",
  "save-changes": "Save changes",
  "sign-out": "Sign out",
  "login-required-message": "Please log in to view and edit your profile.",
  "log-in": "Log in",
  "login-email-title": "Enter your email address",
  "login-sending": "Sending…",
  "login-code-title": "Enter the login code",
  "login-code-description": "We sent a login code to \"{{email}}\".",
  "login-code-placeholder": "Enter login code here",
  "login-change-email": "Change email address",
  "login-resend-code": "Resend code",
  "login-confirm-code": "Confirm code",
  "login-verifying": "Verifying…",
  "login-error-email-required": "Please enter your email address.",
  "login-error-code-required": "Please enter the code from your email.",
  "login-error-generic": "Something went wrong. Please try again.",
  "login-account-title": "Login to your account",
  "login-account-subtitle": "Enter the email address you want to login with",
  "login-agree-prefix": "I agree to the",
  "login-error-terms-required": "Please agree to the terms of service to continue.",
  "terms-of-service": "Terms of service",
  "privacy-policy": "Privacy policy",
  "code-of-conduct": "Code of conduct",
  "tanakh": "Tanakh",
  "traditional": "Traditional",
  "no-chapter-content-found": "No chapter content found.",
  "no-translations-available": "No translations available.",
  "more": "More",
  "themes": "Themes",
  "page-settings": "Page settings",
  "display-and-theme": "Display & Theme",
  "display-and-theme-description": "Pick a theme and tune how Scripture and the UI are displayed.",
  "scripture-settings": "Scripture settings",
  "scripture-elements": "Scripture elements",
  "scripture-settings-font-size-example": "A",
  "scripture-margins": "Scripture Margins",
  "decrease-scripture-margin": "Decrease scripture margin",
  "increase-scripture-margin": "Increase scripture margin",
  "show-headings": "Show headings",
  "show-verse-numbers": "Show verse numbers",
  "show-footnotes": "Show footnotes",
  "show-highlights": "Show highlights",
  "show-red-lettering": "Show red lettering",
  "all-settings": "All settings",
  "download-settings": "Download settings",
  "downloading-settings": "Downloading settings...",
  "upload-settings": "Upload settings",
  "uploading-settings": "Uploading settings...",
  "no-extensions-available": "No extensions available.",
  "install": "Install",
  "uninstall": "Uninstall",
  "reset-toolbar": "Reset toolbar",
  "custom": "Custom",
  "text-section-bookTitle": "Book Title Text",
  "text-section-heading": "Heading Text",
  "text-section-verse": "Verse Text",
  "weight": "Weight",
  "bold": "Bold",
  "regular": "Regular",
  "light": "Light",
  "font": "Font",
  "margin-vertical": "Margin (vertical, px)",
  "margin-horizontal": "Margin (horizontal, px)",
  "reset-text-settings": "Reset text settings",
  "customize-colors": "Customize colors",
  "highlight-colors": "Highlight colors",
  "reset-all-custom-colors": "Reset all custom colors",
  "book-order": "Book order",
  "selection-ui": "Selection UI",
  "show-selected-items": "Show selected items",
  "show-highlight-colors": "Show highlight colors",
  "show-icon-text": "Show icon text",
  "toolbar": "Toolbar",
  "extensions": "Extensions",
  "display": "Display",
  "theme-and-text": "Theme & text",
  "go-to-all-settings": "Go to all settings",
  "keep-screen-awake": "Keep screen awake",
  "language": "Language",
  "report-a-bug": "Report a bug",
  "session-settings-host-only_note": "Only the session host can change these settings.",
  "session-settings-host-only_navigate": "Only host can navigate",
  "session-settings-host-only_highlight": "Only host can highlight",
  "session-settings-highlight-duration": "Highlight for",
  "end-session": "End Session",
  "panels": "Panels",
  "new-shared-session": "New shared session",
  "open-in-new-panel": "Open in new panel",
  "close-sidebar": "Close sidebar",
  "select-pane-layout": "Select pane layout",
  "pane-layout": "Pane layout",
  "back": "Back",
  "selected": "Selected",
  "decrease-scripture-font-size": "Decrease scripture font size",
  "increase-scripture-font-size": "Increase scripture font size",
  "change-line-spacing": "Change line spacing",
  "line-spacing_lineHeight": "Line spacing: {{lineHeight}}",
  "toolbar_description": "Choose which reader toolbar tools appear and in what order.",
  "italic": "Italic",
  "underline": "Underline",
  "alignment_x": "Alignment: {{alignment}}",
  "change_alignment": "Change alignment",
  "pick_text_color": "Pick text color",
  "text_color": "Text color",
  "follow_theme": "Follow theme",
  "reset-to-default": "Reset to default",
  "highlight-text-color": "Highlight text color",
  "highlight-background-color": "Highlight background",
  "id_highlight-text-color": "{{id}} highlight text color",
  "id_highlight-background-color": "{{id}} highlight background color",
  "all-settings-description": "Fine-tune every text section and customize each theme color.",
  "close-footnote": "Close footnote",
  "add-custom-color": "Add custom color",
  "add-color": "Add color",
  "clear-highlight": "Clear highlight",
  "clear": "Clear",
  "highlight": "Highlight",
  "highlight-selection": "Highlight selection",
  "shared-sessions": "Shared sessions",
  "search-translation": "Search translations...",
  "old-testament_short": "OT",
  "new-testament_short": "NT",
  "apocrypha": "Apocrypha",
  "extrabiblical-writings": "Extrabiblical Writings",
  "custom-translations": "Custom translations",
  "no-translation-results-found": "No results found. Would you like to expand your search to include partially complete translations as well?",
  "show-all-translations": "Show all translations",
  "search-books": "Search books...",
  "no-results-found": "No results found.",
  "information-about-this-translation": "Information about this translation",
  "import": "Import",
  "enter-url": "Enter URL",
  "complete-translations": "Complete translations",
  "all-translations": "All translations",
  "popular-translations": "Popular translations",
  "about-extrabiblical-writings": "About Extrabiblical writings",
  "apocrypha-info-text": "None of the writings in this section were ever considered Scripture by early Jewish or Christian communities. The Bible is a specific collection of books. Jews and Christians have always agreed on the Old Testament, which comes from a fixed set of sacred writings the Jewish people called the Tanakh and Christians call the Old Testament. The content of the Tanakh and the Old Testament are exactly the same, but are commonly arranged differently. Christians additionally recognize the New Testament, which tells the story of Jesus, his teachings, and the writings of his followers. The writings below were known and widely read at the time the Bible was written, but they were never treated as Scripture. While ancient authors sometimes quoted a wide range of texts including poets, philosophers, and other writings, quoting something is not the same as treating it as Scripture. These writings are included here for historical and literary reference only.",
  "1-psalms": "1 Psalms",
  "3-psalms": "3 Psalms",
  "4-psalms": "4 Psalms",
  "5-psalms": "5 Psalms",
  "remove-bookmark": "Remove bookmark",
  "add-bookmark": "Bookmark",
  "chat": "Chat",
  "today": "Today",
  "you": "You",
  "bible": "Bible",
  "read-the-bible": "Read the Bible",
  "add-verse": "Add verse",
  "add": "Add",
  "category-options": "Folder options",
  "rename": "Rename",
  "delete": "Delete",
  "bookmark-folder-empty": "No bookmarks here yet.",
  "bookmark-options": "Bookmark options",
  "new-folder-placeholder": "Folder name",
  "tasks": "Tasks",
  "bookmarks": "Bookmarks",
  "hide-bookmarks": "Hide bookmarks",
  "show-bookmarks": "Show bookmarks",
  "add-new-tab": "Add new tab",
  "folder-name-taken": "A folder with that name already exists.",
  "add-to-new": "Add to new",
  "save": "Save",
  "bookmark-verses": "Bookmark",
  "seed-bible-description": "Read {{bookName}} {{chapterNumber}} in the Seed Bible",
  "social-title": "Read {{bookName}} {{chapterNumber}}",
  "new-bookmark-folder": "New folder",
  "chapter-navigation": "Chapter navigation",
  "tutorial.skip": "Skip",
  "tutorial.optOut": "Don't show tutorials",
  "tutorial.back": "Back",
  "tutorial.done": "Done",
  "tutorial.next": "Next",
  "onboarding.installTargetDesktop": "desktop",
  "onboarding.installTargetMobile": "home screen",
  "onboarding.installThanks": "Thanks for installing!",
  "onboarding.installMaybe": "Maybe next time!",
  "onboarding.installUnavailable": "PWA installation is not available",
  "onboarding.installBodyPre": "Add Seed Bible to your ",
  "onboarding.installBodyPost": " to return anytime. You can always find this option later in Settings.",
  "onboarding.iosStepsPre": "Tap ",
  "onboarding.iosStepsPost": " in the toolbar, then choose “Add to Home Screen”.",
  "onboarding.gotIt": "Got it",
  "onboarding.installApp": "Install App",
  "onboarding.maybeLater": "Maybe later",
  "install-app": "Install App",
  "launch-tutorial": "Launch tutorial",
  "search-languages": "Search languages...",
  "no-languages-found": "No languages found",
  "today-coming-soon": "Today screen is coming soon",
  "link-to-join-shared-session-copied": "A link to join the shared session was copied to your clipboard",
  "copied-translation-share-link": "Copied translation share link",
  "less": "Less",
  "swipe-up-more": "Swipe up to see more",
  "plans": "Plans",
  "reading-plans": "Reading plans",
  "create-reading-plan": "Create reading plan",
  "reading-plans-empty": "You don't have any reading plans yet. Create one to get started.",
  "untitled-reading-plan": "Untitled plan",
  "title": "Title",
  "reading-plan-title_placeholder": "e.g. Bible in a Year",
  "reading-plan-description_placeholder": "What is this plan about?",
  "discover": "Discover",
  "playlists": "Playlists",
  "annotations": "Annotations",
  "cross-references": "Cross references",
  "study-notes": "Study notes",
  "content": "Content",
  "untitled-playlist": "Untitled playlist",
  "discover-playlists-empty": "You haven't created any playlists yet.",
  "discover-annotations-empty": "You have no annotations",
  "discover-cross-references-empty": "No cross references for this chapter.",
  "discover-study-notes-empty": "No study notes for this chapter.",
  "discover-content-empty": "No content for this chapter.",
  "discover-select-tab": "Select a tab to discover related material.",
  "create-playlist": "Create",
  "playlist-title_placeholder": "Playlist title",
  "ai": "AI",
  "ai-edit-playlist": "Edit playlist with AI",
  "ai-playlist-chat-prompt": "What do you want to add/change?",
  "items": "Items",
  "playlist-items-empty": "No items yet.",
  "playlist-item-html": "HTML snippet",
  "playlist-item-title-placeholder": "Title (optional)",
  "open-link": "Open",
  "add-to-playlist": "Add to playlist",
  "edit-playlist": "Edit playlist",
  "delete-playlist": "Delete",
  "playlist-options": "Playlist options",
  "delete-playlist-confirm-title": "Delete playlist?",
  "delete-playlist-confirm-message": "Delete \"{{title}}\"? This can't be undone.",
  "delete-playlist-failed": "Couldn't delete the playlist.",
  "remove-playlist-item": "Remove item",
  "edit-playlist-item": "Edit item",
  "playlist-add-item": "Add item",
  "playlist-edit-item": "Edit item",
  "playlist-save-item": "Save changes",
  "playlist-add-scripture-placeholder": "e.g. John 3 or John 3:16",
  "playlist-add-link-placeholder": "https://example.com",
  "playlist-add-button": "Add item",
  "playlist-add-scripture-error": "Couldn't find that reference",
  "playlist-add-link-error": "Enter a valid URL",
  "playlist-add-link-embed": "Embed this link",
  "play-playlist": "Play playlist",
  "stop": "Stop",
  "queue": "Queue",
  "previous": "Previous",
  "next": "Next",
  "editor-format-bold": "Bold",
  "editor-format-italic": "Italic",
  "editor-format-underline": "Underline",
  "editor-align-left": "Align left",
  "editor-align-center": "Align center",
  "editor-align-right": "Align right",
  "editor-align-justify": "Justify",
  "anonymous": "Anonymous",
  "no-chat-messages": "No messages yet",
  "start-conversation": "Start a conversation",
  "presence-one-is-here": "{{name}} is here",
  "presence-many-are-here": "{{count}} people are here",
  "unable-to-send-message": "Unable to send message.",
  "type-a-message": "Type a message...",
  "send-message": "Send message",
  "someone-is-typing": "Someone is typing...",
  "x-and-x-are-typing": "{{first}} and {{second}} are typing...",
  "x-is-typing": "{{name}} is typing...",
  "x-is-typing-and-more": "{{name}} and {{count}} others are typing...",
  "x-is-typing-and-more_one": "{{name}} and one other is typing...",
  "x-is-typing-and-more_other": "{{name}} and {{count}} others are typing...",
  "chat-x-joined": "{{name}} joined",
  "chat-x-and-x-joined": "{{first}} and {{second}} joined",
  "chat-x-and-count-joined": "{{name}} and {{count}} others joined",
  "chat-x-and-count-joined_one": "{{name}} and one other joined",
  "chat-x-and-count-joined_other": "{{name}} and {{count}} others joined",
  "chat-tool-used": "{{name}} used {{count}} tools",
  "chat-tool-used_one": "{{name}} used a tool",
  "chat-tool-used_other": "{{name}} used {{count}} tools",
  "chat-ai-error": "Sorry, something went wrong generating a response ({{error}}).",
  "session-chat-just-you": "In-session chat (Just You)",
  "you-have-no-chats": "You have no chats. Create one using the + button below.",
  "no-chat-providers": "No chat providers are available. Connect an AI or messaging provider to start chatting.",
  "color-emerald": "Emerald",
  "color-blue": "Blue",
  "color-pink": "Pink",
  "color-amber": "Amber",
  "color-violet": "Violet",
  "color-red": "Red",
  "color-green": "Green",
  "color-orange": "Orange",
  "color-cyan": "Cyan",
  "color-rose": "Rose",
  "color-purple": "Purple",
  "color-teal": "Teal",
  "animal-forest": "Forest",
  "animal-park": "Log",
  "animal-eco": "Leaf",
  "animal-pets": "Dog",
  "animal-cruelty_free": "Rabbit",
  "animal-local_cafe": "Coffee",
  "animal-local_florist": "Flower",
  "animal-grass": "Grass",
  "animal-potted_plant": "Plant",
  "animal-nature": "Tree",
  "visual-color-animal-anonymous": "{{color}} {{animal}} (Anonymous)",
  "participants": "Participants",
  "no-participants-match": "No participants match",
  "active": "Active",
  "inactive": "Inactive",
  "available": "Available",
  "everyone": "Everyone",
  "open-chat": "Open chat",
  "tutorial.promptTitle": "Welcome to Seed Bible. Would you like a tutorial?",
  "tutorial.promptBody": "A guided tour is available to help you learn the ins and outs of Seed Bible.",
  "tutorial.promptDecline": "No, thanks",
  "tutorial.promptAccept": "Take the tour",
  "session-id": "Session ID",
  "session-settings-section-navigation": "Navigation",
  "session-settings-section-sharing": "Sharing",
  "session-settings-section-participants": "Participants",
  "collapsed-tab-shared-label": "{{title}} — shared session, {{count}} present",
  "shared": "Shared",
  "host": "Host",
  "co-host": "Co-host",
  "make-co-host": "Make co-host",
  "remove-co-host": "Remove co-host",
  "session-settings-navigate-desc_host": "Only the host can change the passage for everyone.",
  "session-settings-navigate-desc_all": "Everyone in the session can change the passage.",
  "session-settings-highlight-desc_host": "Only the host can highlight for everyone.",
  "session-settings-highlight-desc_all": "Everyone in the session can highlight.",
  "session-settings-share-translation": "Share translation",
  "session-settings-share-translation-desc_shared": "Everyone reads the same translation. Changing it updates it for everyone.",
  "session-settings-share-translation-desc_unique": "Each person keeps their own translation. Changing yours won't affect others.",
  "session-close-confirm-title": "End session?",
  "session-close-confirm-message": "Closing this will end the session for everyone.",
  "appoint-co-host": "Appoint a co-host",
  "appoint-co-host-instructions": "Choose someone to keep the session running:",
  "end-session-for-everyone": "End session",
  "dont-show-again": "Don't show this again",
  "share-playlist": "Share playlist",
  "playlist-url-copied": "Playlist URL copied to clipboard",
  "current-playlist": "Current playlist",
  "playlist-add-mode-label": "Item type",
  "languageUnavailable.title": "Language Unavailable",
  "languageUnavailable.body": "We don't currently have a Bible translation for this language, but we do support {{fallback}}. Would you like to switch the Bible text to {{fallback}} instead?",
  "languageUnavailable.yesContinue": "Yes, Continue",
  "languageUnavailable.noGoBack": "No, Go back",
  "ui-size": "UI size",
  "loading-profile": "Loading your profile…",
  "saving": "Saving…",
  "app-version": "v{{version}} · {{commit}}",
  "move-bookmark": "Move to folder",
  "move-to-new": "Move to new",
  "drag-to-reorder-playlist-item": "Drag to reorder",
  "unsaved-item-confirm-title": "Unsaved item",
  "unsaved-item-confirm-message": "You've started adding an item that hasn't been added to the playlist yet. What would you like to do?",
  "discard-and-save": "Discard and save",
  "add-and-save": "Add and save",
  "share": "Share",
  "share-sheet-title": "Share",
  "share-link": "Share a link",
  "share-link-subtitle": "Copy to clipboard",
  "share-via": "Share via…",
  "share-via-subtitle": "Use your device share sheet",
  "start-share-session": "Start and share session",
  "start-share-session-subtitle": "Invite others to read along live",
  "share-current-session": "Share current session",
  "share-current-session-subtitle": "Copy a link to invite others to read along live",
  "playlist-editor": "Playlist Editor",
  "ai-context-button-label": "Active AI context",
  "ai-context-tool-count": "{{count}} tools",
  "download-translation-offline": "Download for offline use",
  "cancel-translation-download": "Downloading {{percent}}% — tap to cancel",
  "cancel-translation-download-unknown-size": "Downloading {{size}} so far — tap to cancel",
  "saving-translation-to-device": "Saving to this device… {{percent}}% — tap to cancel",
  "translation-available-offline": "Available offline ({{size}}) — tap to remove",
  "update-offline-translation": "A newer version is available — tap to update",
  "retry-translation-download": "Download failed ({{error}}) — tap to retry",
  "translation-downloaded": "{{name}} is now available offline",
  "translation-download-failed": "Couldn't download {{name}}.",
  "translation-removed-from-device": "{{name}} was removed from this device",
  "remove-offline-translation-title": "Remove download?",
  "remove-offline-translation-message": "Remove \"{{name}}\" from this device? You'll need a connection to read it again.",
  "remove-offline-translation-failed": "Couldn't remove the download.",
  "remove": "Remove",
  "signed-out-message": "You've been signed out. Please sign in again.",
  "account-suspended-message": "Your account has been suspended.",
  "loading-chapter": "Loading chapter…",
  "chapter-unavailable": "Chapter unavailable",
  "chapter-unavailable-description": "We were unable to load the data for this chapter. Please check your internet connection and try again.",
  "reload": "Reload",
  "book-not-found-title": "Book not found",
  "book-not-found-message": "We couldn't find that book in {{translationName}}.",
  "book-not-found-action": "Go to {{bookName}} {{chapterNumber}}",
  "chapter-meta-description": "{{bookName}} {{chapterNumber}} ({{translationName}}): {{excerpt}}",
  "app-meta-description": "Read, search, and study the Bible online. Free translations in many languages, with highlights, notes, bookmarks, and reading plans.",
  "loading-picture-editor": "Loading the picture editor…",
  "swipe-to-see-more": "Swipe to see more",
  "show-more-languages": "Show more languages",
  "translation-book-coverage": "{{included}} of {{total}} books",
  "showing-languages-count": "Showing {{shown}} of {{total}}",
  "create-reading-plan-wizard": "Create new plan",
  "edit-reading-plan": "Edit plan",
  "reading-plan-step-name-title": "Name your plan",
  "reading-plan-step-name-hint": "Give your plan a name people will recognise",
  "reading-plan-name-placeholder": "e.g. My Psalms Journey",
  "reading-plan-description-label": "Description (optional)",
  "reading-plan-step-scripture-title": "Select readings",
  "reading-plan-step-cadences-title": "Reading cadences",
  "reading-plan-step-cadences-hint": "Choose the reading paces you want to offer. Readers can always choose to go at their own pace instead.",
  "reading-plan-cadence-once-daily": "One session a day",
  "reading-plan-cadence-twice-daily": "Two sessions a day",
  "reading-plan-cadence-three-times-daily": "Three sessions a day",
  "reading-plan-cadence-every-other-day": "One session every other day",
  "reading-plan-cadence-length": "Finishes in {{count}} days",
  "reading-plan-cadence-length_one": "Finishes in {{count}} day",
  "reading-plan-cadence-length_other": "Finishes in {{count}} days",
  "reading-plan-choose-pace": "How do you want to read it?",
  "reading-plan-pace-self": "At my own pace",
  "reading-plan-pace-self-description": "Read one session at a time, with no schedule",
  "reading-plan-sessions-hint": "Add the readings for each session — scripture, text, or a link",
  "reading-plan-session-label": "Session {{number}}",
  "reading-plan-session-reading-count": "{{count}} readings",
  "reading-plan-session-reading-count_one": "{{count}} reading",
  "reading-plan-session-reading-count_other": "{{count}} readings",
  "reading-plan-session-empty": "No readings yet in this session",
  "reading-plan-add-session": "Add session",
  "reading-plan-remove-session": "Remove session",
  "reading-plan-session-count-sessions": "{{count}} sessions",
  "reading-plan-session-count-sessions_one": "{{count}} session",
  "reading-plan-session-count-sessions_other": "{{count}} sessions",
  "reading-plan-session-short": "Session",
  "reading-plan-progress-sessions": "{{done}}/{{total}} sessions",
  "reading-plan-min-per-session": "~{{count}} min/session",
  "reading-plan-mark-session-complete": "Mark session {{day}} complete",
  "reading-plan-celebration-session-title": "Session {{day}} complete!",
  "reading-plan-next-session": "Next: Session {{day}} · {{readings}}",
  "reading-plan-drafts": "Drafts",
  "reading-plan-draft-summary": "Draft · {{count}} readings",
  "reading-plan-draft-summary_one": "Draft · {{count}} reading",
  "reading-plan-draft-summary_other": "Draft · {{count}} readings",
  "reading-plan-discard-draft": "Discard",
  "reading-plan-discard-draft-confirm": "Delete for good?",
  "reading-plan-draft-saving": "Saving…",
  "reading-plan-draft-saved": "Draft saved",
  "reading-plan-draft-save-failed": "Couldn't save draft",
  "added-to-reading-plan-session": "Added to session {{session}}",
  "reading-plan-add-reading": "Add",
  "reading-plan-scripture-remove": "Remove reading",
  "reading-plan-create-submit": "Create plan",
  "reading-plan-save-changes": "Save changes",
  "reading-plan-create-error": "Something went wrong creating your plan. Please try again.",
  "reading-plan-no-readings": "Add at least one reading to create the plan",
  "reading-plan-needs-name": "Give your plan a name to save it",
  "reading-plan-delete": "Delete",
  "reading-plan-delete-confirm": "Delete for good?",
  "reading-plan-load-failed": "Couldn't load this plan. Please try again.",
  "loading": "Loading…",
  "reading-plan-not-started": "Not started",
  "reading-plan-start": "Start plan",
  "reading-plan-session-count": "{{count}} readings",
  "reading-plan-progress-readings": "{{done}} of {{total}} readings",
  "reading-plan-streak": "{{count}}-day streak",
  "reading-plan-today": "Today",
  "reading-plan-mark-complete": "Mark as complete",
  "reading-plan-day-completed": "Completed",
  "reading-plan-empty-sessions": "This plan doesn't have any readings yet.",
  "reading-plan-celebration-title": "Day {{day}} complete!",
  "reading-plan-complete-title": "Plan complete!",
  "reading-plan-celebration-subtitle": "Great work. Keep the momentum going.",
  "reading-plan-back-to-plan": "Back to plan",
  "reading-plan-duration-days": "{{count}} days",
  "reading-plan-started-on": "started {{date}}",
  "reading-plan-ends-on": "ends {{date}}",
  "reading-plan-progress-days": "{{done}}/{{total}} days",
  "reading-plan-min-per-day": "~{{count}} min/day",
  "reading-plan-day-short": "Day",
  "reading-plan-reading-read": "Read",
  "reading-plan-reading-mins": "~{{count}} min",
  "reading-plan-reading-chapters": "Chapters",
  "reading-plan-reading-chapters-done": "{{done}} of {{total}} chapters",
  "reading-plan-read-day": "Read",
  "reading-plan-reflect": "Reflect",
  "reading-plan-mark-day-complete": "Mark Day {{day}} complete",
  "reading-plan-finish-readings": "Finish all readings to complete the day",
  "reading-plan-today-eyebrow": "Today · Day {{day}}",
  "reading-plan-active": "Active",
  "reading-plan-completed": "Completed",
  "reading-plan-next": "Next: Day {{day}} · {{readings}}",
  "reading-plan-days-behind": "{{count}} days behind",
  "reading-plan-finished": "Finished {{date}}",
  "reading-plan-restart": "Restart",
  "add-to-reading-plan": "Add to plan",
  "reading-plan-untitled-reading": "Reading",
  "reading-plan-preview-reading": "Preview {{reading}}",
  "reading-plan-mark-reading-complete": "Mark reading complete",
  "reading-plan-link-video": "Video",
  "reading-belongs-to": "This reading belongs to",
  "reading-plan-read-nudge": "You've read this passage — mark it complete?",
  "reading-plan-mark-passage-complete": "Mark {{passage}} as read",
  "reading-plan-read-nudge-title": "Nice reading!",
  "reading-plan-read-nudge-toast": "Mark {{passage}} complete?",
  "reading-plan-nudge-later": "Not now",
  "session-host-reconnecting": "Reconnecting to the session…",
  "session-host-reconnected": "Reconnected to the session",
  "session-host-left": "The host left — you were removed from the session",
  "create-menu": "Create",
  "create-annotation-menu-item": "Annotation",
  "create-playlist-menu-item": "Playlist",
  "annotate-title": "Annotate {{location}}",
  "annotation-options": "Annotation options",
  "edit-annotation": "Edit",
  "delete-annotation": "Delete",
  "delete-annotation-confirm-title": "Delete annotation?",
  "delete-annotation-confirm-message": "Delete this annotation? This can't be undone.",
  "delete-annotation-failed": "Couldn't delete the annotation.",
  "save-annotation-failed": "Couldn't save the annotation.",
  "annotation-group-expand": "Expand group",
  "annotation-group-collapse": "Collapse group",
  "annotation-comment-updated": "Updated {{date}}",
  "notes": "Notes",
  "note": "Note",
  "show-more-verse-actions": "Show more actions",
  "show-fewer-verse-actions": "Show fewer actions",
  "x-notes": "{{count}} notes",
  "x-notes_one": "{{count}} note",
  "x-notes_other": "{{count}} notes",
  "chapter-notes-count": "{{count}} notes for this chapter",
  "chapter-notes-count_one": "{{count}} note for this chapter",
  "chapter-notes-count_other": "{{count}} notes for this chapter"
}
